import { ref, toRaw, getCurrentScope, onScopeDispose } from 'vue'
import i18next from 'i18next'
import { useTranslations } from '@/composables'

export default function useLanguage() {
  const { load } = useTranslations()
  const language = ref(i18next.language)
  const isChangingLanguage = ref(false)

  const change = language => {
    console.info(`changing app language to ${language}`)
    isChangingLanguage.value = true
    load(language)
      .then(translations => {
        i18next.addResourceBundle(language, 'translation', toRaw(translations), true, true)
        i18next.changeLanguage(language)
      })
      .catch(error => console.warn(`Texts for ${language} could not be loaded, the language stays`, error))
      .finally(() => {
        isChangingLanguage.value = false
      })
  }

  const initialize = async language => {
    console.info(`initializing app with ${language} language`)
    return load(language).then(translations => {
      i18next.addResourceBundle(language, 'translation', toRaw(translations), true, true)
    })
  }

  // i18next singleton, not useTranslation(): that needs a Vue instance, and change() is called outside components
  const onLanguageChanged = lng => {
    language.value = lng
  }
  i18next.on('languageChanged', onLanguageChanged)
  if (getCurrentScope()) onScopeDispose(() => i18next.off('languageChanged', onLanguageChanged))

  return {
    language,
    isChangingLanguage,
    change,
    initialize,
  }
}
